/**
 * Created by Andrey Popov on 20.08.2026.
 */

const RewardedPromoRulesWindow = GuideWindow.extend({
    onWindowLoaded: function (promotion) {
        this.promotion = promotion;

        this._super({
            name: "RewardedPromoRulesWindow",
            title: RewardedPromo.WindowTitle("RewardedPromoRulesWindow"),
            bundle: bundles.rewardedpromoruleswindow,
            toReplace: {
                name: RewardedPromotion.GetProjectTitle(promotion.projectId),
                hostName: RewardedPromotion.GetProjectTitle(cleverapps.config.name)
            }
        });
    },

    listSpines: function () {
        const projectBundle = bundles[this.promotion.getBundleName()];

        return [
            projectBundle && projectBundle.jsons.guide_stages_1 || this.bundle.jsons.guide_stages_1,
            this.bundle.jsons.guide_stages_2,
            this.bundle.jsons.guide_stages_3
        ].filter(Boolean);
    },

    listBundles: function (promotion) {
        return ["rewardedpromoruleswindow", promotion.getBundleName()];
    }
});
